const Vue = require('vue')
import apihelper from './apihelper'

export default {
    select(p) {
        return apihelper.get("/Order/Select", p);
    }
}